/**
 * @augments 导出两个组件TableContainer和WhiteSpace
 * @desc TableContainer: 表格区域样式
 *                    （包括 firstPart:  表格上部分的汇总信息
 *                          secondPart: 导出或者其他搜索条件操作
 *                          thirdPart:  表格或者其他等内容）
 *        props: isTab?                  [boolean]      如果是tab表格的话，需要传入此参数，默认false非tab
 *               hasExport?              [boolean]      表格上部分是否有导出按钮，默认true有导出按钮
 *               totalNum?               [number]       表格上部分汇总条数
 *               selfText?               [ReactNode]    自定义文本内容
 *               hasLine?                [boolean]      默认false否, 此为第一部分内部样式中的一种，推荐用firstPartStyle或firstPartClassName代替
 *               onlyChildInExportLine?  [boolean]      如果此组件只有一个child，是否和导出展示在一行，默认false不展示在导出行
 *               exportObj?              [
 *                                         type: 'auction' | 'base' | 'finance' | 'goods' | 'order' | 'system' | 'user',  // 导出模块
 *                                          params: {
 *                                            [key: string]: any,
 *                                          },                                                                            // 查询参数
 *                                          fileName: string,                                                             // 下载文件名
 *                                          allow?: string,                                                               // 如果需要权限，请传allow
 *                                        ]             导出配置参数
 *               style?                    [object]    样式
 *               className?                [string]    类名
 *               firstPartStyle?           [object]    第一部分样式
 *               firstPartClassName?       [string]    第一部分类名
 *               secondPartStyle?          [object]    第二部分样式
 *               secondPartClassName?      [string]    第二部分类名
 *               exportStyle?              [object]    导出样式
 *               exportClassName?          [string]    导出类名
 *
 * @desc WhiteSpace 上下留白组件, 默认是30px
 *        props: h         [number]    留白的高度，默认是30(单位均为px)
 */
import { __rest } from "tslib";
import React, { Component } from 'react';
import { Root, Body, BodyTop, Line } from './style/index';
import { Button } from 'antd';
import { getState } from '@@/store';
import { judgeObj } from '@/shared/functions';
import API from '@/services';
function wapperTableContainer(Component) {
    return class extends React.Component {
        render() {
            const _a = this.props, { isTab } = _a, props = __rest(_a, ["isTab"]);
            const noTabComponent = (<Body>
          <Component {...props}/>
        </Body>);
            const tabComponent = (<Component {...props}/>);
            return !!isTab ? tabComponent : noTabComponent;
        }
    };
}
class TableContent extends Component {
    render() {
        const { children, hasExport, hasLine, totalNum, selfText, onlyChildInExportLine = false, style, className, firstPartStyle, firstPartClassName, secondPartStyle, secondPartClassName, exportClassName, exportStyle, exportObj, } = this.props;
        const childrenLen = React.Children.count(children);
        const childrenArr = React.Children.toArray(children);
        const secAndRestChildren = childrenArr.slice(1);
        return (<Root style={style} className={className}>
        <BodyTop className="table__top">
          
          {(totalNum !== undefined || selfText !== undefined) &&
            <Line className={`${hasLine ? 'topLine' : 'top__line-fir'} ${firstPartClassName}`} style={firstPartStyle}>
                {totalNum !== undefined ? `共搜索到${totalNum}条数据` : selfText}
              </Line>}
          
          {(childrenLen > 1 || (childrenLen === 1 && onlyChildInExportLine) || hasExport) &&
            <Line className={`top__line-sec ${secondPartClassName}`} style={secondPartStyle} hasExport={hasExport} setMinHeight={hasExport && childrenLen <= 1 && !onlyChildInExportLine}>
              {childrenLen === 1 && onlyChildInExportLine && children}
              {childrenLen > 1 && childrenArr[0]}
              {hasExport &&
                <ExportBtn className={`export abs_hasExport ${exportClassName}`} style={exportStyle} exportObj={exportObj}/>}
            </Line>}
        </BodyTop>
        
        {childrenLen === 1 && !onlyChildInExportLine && children}
        {childrenLen > 1 &&
            React.Children.map(secAndRestChildren, (child) => child)}
      </Root>);
    }
}
TableContent.defaultProps = {
    hasExport: true,
};
function ExportBtn(props) {
    const { exportObj, className, style, btnText = '导出' } = props;
    // 导出功能（文件流）
    const onExport = () => {
        if (judgeObj(exportObj)) {
            const { type, params, fileName } = exportObj;
            // 拼接下载地址
            API[type].globalExport(Object.assign({}, params)).then((res) => {
                const content = res;
                const elink = document.createElement('a');
                elink.download = `${fileName}.xls`; // 设置下载文件名
                elink.style.display = 'none';
                const blob = new Blob([content]);
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                document.body.removeChild(elink);
            });
        }
        else {
            console.warn('导出参数exportObj不合法');
        }
    };
    // 导出权限
    const getAllow = () => {
        if (judgeObj(exportObj)) {
            const { allow } = exportObj;
            if (allow) {
                const userAuth = getState().global.resources;
                // console.log('我拥有的权限：', userAuth);
                // console.log('目前导出需要的权限', allow);
                if (userAuth.includes(allow)) {
                    // console.log('真棒，我有目前的导出权限');
                    return true;
                }
                return false;
            }
            return true;
        }
        return false;
    };
    return getAllow() ? (<Button className={className} style={style} onClick={onExport}>
      {btnText}
    </Button>) : null;
}
const TableContainer = wapperTableContainer(TableContent);
export default TableContainer;
export { WhiteSpace } from './style/index';
export { ExportBtn };
